import { Button, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import NotifyTable from "./NotifyTable";
import { useNavigate } from "react-router-dom";

const SettingNotify = ({
    isLoading = false,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Space style={{ width: "100%" }} size={24} direction="vertical">
            <Row justify="end">
                <Button
                    type="primary"
                    style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                    icon={<CreateIcon style={{ fontSize: 16 }} />}
                    onClick={() => {
                        navigate("/masterdata/setting_notification/create_notify")
                    }}
                >
                    {t("common.create")}
                </Button>
            </Row>

            <NotifyTable
                isLoading={isLoading}
            />
        </Space>
    )
}

export default SettingNotify;